export default "__VITE_ASSET__FlDxIdA7__"